'use strict';

// This file must be included in an environment that also includes the ClipboardJS library.
/* global ClipboardJS */

(function (snapOnline, $) {
    // ----- Public interface from here -----

    // An empty function (that can be used with Promises, for example).
    snapOnline.noop = function () {
    };

    // Encodes a string to make it safe for use in a Kendo ClientTemplate.
    snapOnline.kendoEncode = function (value) {
        return value.replace("'", '&apos;');
    };

    // Get the filters from a Kendo grid. Its a [DataSourceRequest] in theory
    snapOnline.kendoGridFilterQuery = function (gridName) {
        var filterState = '';
        var grid = $('#' + gridName);
        if (grid !== null) {
            grid = grid.data('kendoGrid');
        }
        if (grid !== null) { 
            var dataSourceState = grid.dataSource.transport.parameterMap({ filter: grid.dataSource.filter(), sort: grid.dataSource.sort() });
            filterState = '&filter=' + dataSourceState.filter
                        + '&group=' + dataSourceState.group
                        + '&sort=' + dataSourceState.sort;
        }
        return filterState;
    };


    // Gets the Snap Online base URL, from a meta tag.  The URL
    // will *not* include a trailing slash.
    snapOnline.getSolBaseUrl = function () {
        var url = $('meta[name="sol-base"]').attr('value');
        if (url.charAt(url.length - 1) === '/') {
            url = url.substring(0, url.length - 1);
        }
        return url;
    };

    // Gets a string containing the GUID of the current Resource.
    snapOnline.getCurrentResourceId = function () {
        return $('meta[name="sol-resource-id"]').attr('value');
    };

    // Obtain the anti-forgery token embedded in the current page.
    snapOnline.getRequestVerificationToken = function () {
        return $('input[name="__RequestVerificationToken"]').val();
    };

    // Returns a string containing the URL path of the specified ASP.NET MVC Controller.
    snapOnline.getControllerUrl = function (controllerName) {
        return [snapOnline.getSolBaseUrl(), controllerName].join('/');
    };

    // Returns a string containing the URL path to the specified ASP.NET MVC Action.
    snapOnline.getActionUrl = function (controllerName, actionName) {
        return [snapOnline.getSolBaseUrl(), controllerName, actionName].join('/');
    };

    // Returns a string containing the URL path to the specified ASP.NET MVC Action,
    // for the current (default) or specified resource, with optional query-string parameters.
    snapOnline.getResourceActionUrl = function (controllerName, actionName, resourceId, params) {
        var url = [
            snapOnline.getActionUrl(controllerName, actionName),
            resourceId || snapOnline.getCurrentResourceId()
        ].join('/');
        return params ? [url, $.param(params)].join('?') : url;
    };

    // An alternative for Ajax.ActionLink() that can be called from code, linked to buttons etc.
    snapOnline.replaceElementWithAjaxGet = function (elementId, url, onSuccess) {
        return new Promise(function (resolve, reject) {
            jQuery.get(url)
                .done(function (response) {
                    $('#' + elementId).html(response);
                    resolve(response);
                    if (typeof onSuccess === 'function') {
                        onSuccess();
                    }
                })
                .fail(function (jqXhr, textStatus, errorThrown) {
                    reject(jqXhr, textStatus, errorThrown);
                });
        });
    };

    // Returns HTML for an image tag that shows an icon indicating an enabled or disabled state.
    // The enabled and disabled titles can optionally be provided.
    snapOnline.getEnabledDisabledImage = function (value, enabledTitle, disabledTitle) {
        enabledTitle = (typeof enabledTitle === 'undefined') ? 'Enabled' : enabledTitle;
        disabledTitle = (typeof disabledTitle === 'undefined') ? 'Disabled' : disabledTitle;
        if (value) {
            return '<img src="' + snapOnline.getSolBaseUrl() + '/Content/Images/btn-icon-green-tick.png" title="' + enabledTitle + '" />';
        } else {
            return '<img src="' + snapOnline.getSolBaseUrl() + '/Content/Images/btn-icon-red-cross.png" title="' + disabledTitle + '" />';
        }
    };

    // Returns HTML for an image tag that shows an icon indicating a yes, no, don't know state.
    snapOnline.getYesNoDontKnowImage = function (value) {
        if (value === 0) {
            return '<img src="' + snapOnline.getSolBaseUrl() + '/Content/Images/btn-icon-red-cross.png" title="Don\'t know" />';
        } else if (value === 1) {
            return '<img src="' + snapOnline.getSolBaseUrl() + '/Content/Images/btn-icon-green-tick.png" title="Yes" />';
        } else {
            return '<img src="' + snapOnline.getSolBaseUrl() + '/Content/Images/btn-icon-red-cross.png" title="No" />';
        }
    };

    // Returns HTML for an image tag that shows an 'positive' icon if value=true, or nothing otherwise.
    snapOnline.getEnabledImageIfTrue = function (value, enabledTitle) {
        return value ? snapOnline.getEnabledDisabledImage(true, enabledTitle) : '';
    };

    // Returns HTML for an image tag that shows an 'warning' icon if value=true, or nothing otherwise.
    snapOnline.getWarningImageIfTrue = function (value, warningTitle) {
        warningTitle = (typeof warningTitle === 'undefined') ? 'Warning' : warningTitle;
        return value ? '<img src="' + snapOnline.getSolBaseUrl() + '/Content/Images/btn-icon-red-exclamation.png" title="' + warningTitle + '" />' : '';
    };

    // Returns HTML for an image tag that shows a "please wait" spinner.
    snapOnline.getWaitSpinnerImage = function (size) {
        var filename = (size === 'small') ? 'smallspinner.gif' : 'spinner.gif';
        return '<img src="' + snapOnline.getSolBaseUrl() + '/Content/Images/' + filename + '" title="Please wait..." alt=""/>';
    };

    // Returns a Boolean indicating if the current script is hosted inside an IFrame.
    snapOnline.isInIframe = function () {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    };

    // Handles the click in a clickable drop-down button / menu.
    snapOnline.showDropDown = function (e) {
        var target = $(e.srcElement).closest('.clickable-dropdown').find('.dropdown-content').first();
        if ((target.length > 0) && (target.css('display') === 'none')) {
            e.stopPropagation();
            target.css('display', 'inline-block');
            $(document).one('click', function () { target.css('display', 'none'); });
        }
    };

    // 'Flashes' the elements in the specified jQuery selection, to draw attention to them.
    snapOnline.flashSelection = function (jquerySelection) {
        jquerySelection.fadeIn(100).fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100);
    };

    // Called when a user clicks on a menu-item within an accordion panel.  It updates the DOM to highlight the "current page".
    snapOnline.onAccordionItemClicked = function (sender) {
        if (sender) {
            var element = $(sender);
            element.siblings().removeClass('active');
            element.addClass('active');
        }
    };

    // Handles the click on an Accordion header, where the accordion is essentially a "section-based menu".
    // Replaces the MainPanel with the specified URL, and highlights the first item in the section.
    snapOnline.onAccordionPanelClicked = function (sender, url) {
        if (url) {
            snapOnline.replaceElementWithAjaxGet('MainPanel', url);
        }
        if (sender) {
            var menuItems = $(sender).next().find('ul.sublist li');
            menuItems.removeClass('active');
            menuItems.first().addClass('active');
        }
    };

    snapOnline.datePicker = function (element) {
        var format = $('meta[name="sol-date-format"]').attr('value');

        element.kendoDatePicker({
            format: format // set custom defined format
        });
    };

    // Returns the value of the specified cookie, or NULL if no such cookie is found.
    snapOnline.getCookie = function (cookieName) {
        cookieName += '=';
        var cookies = document.cookie.split(';');
        for (var n = 0; n < cookies.length; n++) {
            var item = cookies[n].trim();
            if (item.indexOf(cookieName) === 0) {
                return item.substring(cookieName.length, item.length);
            }
        }
        return null;
    };

    // Returns a promise that resolves when a cookie with the specified name exists, or rejects if a timeout is reached first.
    snapOnline.waitForCookie = function (cookieName, timeout) {
        var remainingAttempts = timeout || 30;
        return new Promise(function (resolve, reject) {
            var downloadInterval = setInterval(function () {
                if (snapOnline.getCookie(cookieName)) {
                    clearInterval(downloadInterval);
                    resolve();
                }
                if (remainingAttempts-- <= 0) {
                    clearInterval(downloadInterval);
                    reject();
                }
            }, 1000);
        });
    };

    // Set an IFrame's height to fit its contents.
    snapOnline.setIframeHeightToFitContents = function (frame, minimumHeight) {
        frame.style.height = 0;
        // Note: the "24" on the line below is an unfortunate but apparently-necessary "magic number", without
        // which the IFrame seems to end up slightly too small.
        frame.style.height = (Math.max(minimumHeight || 0, frame.contentWindow.document.body.scrollHeight) + 24) + 'px';
    };

    snapOnline.showSpinner = function () {
        $('#waitSpinner').show();
    };

    snapOnline.ShowBuildTab = function (id) {
        var prompt = 'Are you sure you want to allow access to the build tab?';
        snapOnline.Dialogs.confirmDialog(prompt, 'Access build tab?').then(function () {
            var url = snapOnline.getResourceActionUrl('UAResource', 'ToggleBuildTab', id);
            jQuery.post(url, { __RequestVerificationToken: snapOnline.getRequestVerificationToken(), hideBuildTab: false });
        }, snapOnline.noop);
    };

    snapOnline.HideBuildTab = function (id) {
        var prompt = 'Are you sure you want to hide access to the build tab?';
        snapOnline.Dialogs.confirmDialog(prompt, 'Hide build tab?').then(function () {
            var url = snapOnline.getResourceActionUrl('UAResource', 'ToggleBuildTab', id);
            jQuery.post(url, { __RequestVerificationToken: snapOnline.getRequestVerificationToken(), hideBuildTab: true });
        }, snapOnline.noop);
    };

    snapOnline.forceRefresh = function () {
        window.location = window.location.href;
    };

    snapOnline.checkForInvalidCharacters = function () {
        var invalidCharDetected = jQuery('#UserName').val().indexOf('<', 0) > 0 || jQuery('#UserName').val().indexOf('>', 0) > 0;
        if (invalidCharDetected) {
            var prompt = 'User name not permitted to have < or >';
            snapOnline.Dialogs.messageDialog(prompt, 'Invalid characters');
        }
        return !invalidCharDetected;
    };

    snapOnline.initializeClipboard = function (button) {
        var clipboard = new ClipboardJS(button, {
            text: function () {
                return $(button).attr('data-copyable-text');
            }
        });

        clipboard.on('success', function (e) {
            e.clearSelection();
            var label = jQuery('<span/>').addClass('copyableTextCopied margin-left-1em').text('Copied').delay(800).fadeOut(500, function () {
                $(this).remove();
            });
            $(e.trigger).closest('.sol-input-addon-container').first().after(label);
        });

        return clipboard;
    };

    snapOnline.toggleMFASettings = function () {
        $('#mfaOptions').toggleClass('hidden');
    };

    snapOnline.initMFASettings = function () {
        var enableMFA = $('#enableMFA');
        if (enableMFA[0].checked) {
            $('#mfaOptions').removeClass('hidden');
        } else {
            $('#mfaOptions').addClass('hidden');
        }
    };

    snapOnline.launchMFAConfigureDialog = function () {
        $('#configureEmail').css({ top: '50px', height: '0px', width: '400px', paddingLeft: '10px' });
        $('#configureApp').css({ top: '50px', height: '0px', width: '400px' });
        var windowObject = snapOnline.Dialogs.createDynamicDialogWindow(600, 'Configure MFA');
        windowObject.refresh(snapOnline.getResourceActionUrl('Account', 'ConfigureMFA'));
        windowObject.open();
    };

    snapOnline.closeMFADialog = function (message) {
        snapOnline.replaceElementWithAjaxGet('MainPanel', snapOnline.getResourceActionUrl('Account', 'Security'));
        if ((message === '') || (message === null)) {
            snapOnline.Dialogs.closeDynamicDialogWindow();
        } else {
            snapOnline.Dialogs.messageDialog(message, 'Configure MFA');
        }
    };

    snapOnline.uiQwizardResize = function () {
        var interviewFrame = $("#UiFrame");
        interviewFrame.css('width', '100%');
        var height = $(window).height();
        interviewFrame.css('height', height - interviewFrame.offset().top - 6);
    };

    snapOnline.initUiQwizardResize = function () {
        window.addEventListener("resize", snapOnline.uiQwizardResize)
        snapOnline.uiQwizardResize();
    };

    snapOnline.initUiQwizardToken = function () {
        //Found I had to grab the request verification token that the mvc helper inserted
        //and create a hidden field in code and append it to the form so that when navigating
        //through the wizard the Next method on the qwizard controller can be reached.
        var sToken = document.getElementsByName("__RequestVerificationToken")[0];
        var tokenVal = "";        
        if (sToken) {
            tokenVal = sToken.value;
        }
        var interviewFrame = $("#UiFrame").contents();
        var FrameToken = interviewFrame.find('#SnapForm input[name = __RequestVerificationToken]');
        if (FrameToken.length) {
            FrameToken[0].value = tokenVal;
        }
        else {
            var hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = '__RequestVerificationToken';
            hiddenInput.value = tokenVal;
            var form = interviewFrame.find('#SnapForm');
            form[0].appendChild(hiddenInput);
        }

    };
    snapOnline.initUIQwizardFrame = function () {
        if (typeof onPageLoad === "function") {
            onPageLoad();
        }
        snapOnline.initUiQwizardToken();
        snapOnline.initUiQwizardResize();
        snapOnline.updateHelpUrl();
    };

    snapOnline.deleteTrustedDevice = function (ID, deviceName) {
        snapOnline.Dialogs.confirmDialog('Are you sure you want to delete "' + deviceName + '"?', 'Delete trusted device').then(function () {
            var url = snapOnline.getResourceActionUrl('Account', 'DeleteTrustedDevice', ID);
            jQuery.post(url, { __RequestVerificationToken: snapOnline.getRequestVerificationToken() })
                .done(function (response) {
                    $('#MainPanel').html(response);
                });
        }, snapOnline.noop);
    };

    snapOnline.updateHelpUrl = function () {
        var currentUrl = window.location.href;
        var splitUrl = currentUrl.split('/').reverse();
        var url = snapOnline.getResourceActionUrl('Survey', 'HelpUrl', splitUrl[0]);
        jQuery.getJSON(url, function (data, state) {
            if (typeof (data) === 'string' && data !== "") {
                var helpElement = $('#HelpUrl')[0];
                if (typeof (helpElement) !== 'undefined') {
                    helpElement.setAttribute('href', data);
                }
            }
        });
    };

}(window.SnapOnline = window.SnapOnline || {}, jQuery));
